// ------ autocompletes
export const AUTOCOMPLETE_OFF = 'off';


export const AUTOCOMPLETE_BIRTHDAY = 'bday';
export const AUTOCOMPLETE_BIRTHDAY_DAY = 'bday-day';
export const AUTOCOMPLETE_BIRTHDAY_MONTH = 'bday-month';
export const AUTOCOMPLETE_BIRTHDAY_YEAR = 'bday-year';

export const AUTOCOMPLETE_EMAIL = 'email';

export const AUTOCOMPLETE_LANGUAGE = 'language';

export const AUTOCOMPLETE_NAME = 'name';
export const AUTOCOMPLETE_NAME_GIVEN = 'given-name';
export const AUTOCOMPLETE_NAME_ADDITIONAL = 'additional-name';
export const AUTOCOMPLETE_SURNAME = 'family-name';

export const AUTOCOMPLETE_PASSWORD_CURRENT = 'current-password';
export const AUTOCOMPLETE_PASSWORD_NEW = 'new-password';

export const AUTOCOMPLETE_ONE_TIME_CODE = 'one-time-code';

export const AUTOCOMPLETE_ORGANIZATION = 'organization';
export const AUTOCOMPLETE_ORGANIZATION_TITLE = 'organization-title';

export const AUTOCOMPLETE_STREET_ADDRESS = 'street-address';
export const AUTOCOMPLETE_ADDRESS_LINE_1 = 'address-line1';
export const AUTOCOMPLETE_ADDRESS_LINE_2 = 'address-line2';
export const AUTOCOMPLETE_ADDRESS_LINE_3 = 'address-line3';
export const AUTOCOMPLETE_ADDRESS_LEVEL_4 = 'address-level4';
export const AUTOCOMPLETE_ADDRESS_LEVEL_3 = 'address-level3';
export const AUTOCOMPLETE_ADDRESS_LEVEL_2 = 'address-level2';
export const AUTOCOMPLETE_ADDRESS_LEVEL_1 = 'address-level1';
export const AUTOCOMPLETE_COUNTRY = 'country';
export const AUTOCOMPLETE_COUNTRY_NAME = 'country-name';
export const AUTOCOMPLETE_POSTAL_CODE = 'postal-code';

export const AUTOCOMPLETE_CC_NAME = 'cc-name';
export const AUTOCOMPLETE_CC_NAME_GIVEN = 'cc-given-name';
export const AUTOCOMPLETE_CC_NAME_ADDITIONAL = 'cc-additional-name';
export const AUTOCOMPLETE_CC_SURNAME = 'cc-family-name';
export const AUTOCOMPLETE_CC_NUMBER = 'cc-number';
export const AUTOCOMPLETE_CC_EXPIRY = 'cc-exp';
export const AUTOCOMPLETE_CC_EXPIRY_MONTH = 'cc-exp-month';
export const AUTOCOMPLETE_CC_EXPIRY_YEAR = 'cc-exp-year';
export const AUTOCOMPLETE_CC_CSC = 'cc-csc';
export const AUTOCOMPLETE_CC_TYPE = 'cc-type';

export const AUTOCOMPLETE_TRANSACTION_CURRENCY = 'transaction-currency';
export const AUTOCOMPLETE_TRANSACTION_AMOUNT = 'transaction-amount';

export const AUTOCOMPLETE_URL = 'url';

export const AUTOCOMPLETE_PHOTO = 'photo';

export const AUTOCOMPLETE_TEL = 'tel';
export const AUTOCOMPLETE_TEL_COUNTRY_CODE = 'tel-country-code';
export const AUTOCOMPLETE_TEL_NATIONAL = 'tel-national';
export const AUTOCOMPLETE_TEL_AREA_CODE = 'tel-area-code';
export const AUTOCOMPLETE_TEL_LOCAL = 'tel-local';
export const AUTOCOMPLETE_TEL_LOCAL_PREFIX = 'tel-local-prefix';
export const AUTOCOMPLETE_TEL_LOCAL_SUFFIX = 'tel-local-suffix';
export const AUTOCOMPLETE_TEL_EXTENSION = 'tel-extension';

export const AUTOCOMPLETE_USERNAME = 'username';
export const AUTOCOMPLETE_USERNAME_NEW = 'new-username';


export const AUTOCOMPLETES = [
    AUTOCOMPLETE_OFF,

    AUTOCOMPLETE_EMAIL,
    AUTOCOMPLETE_NAME,
    AUTOCOMPLETE_NAME_ADDITIONAL,
    AUTOCOMPLETE_NAME_GIVEN,
    AUTOCOMPLETE_SURNAME,
    AUTOCOMPLETE_PASSWORD_CURRENT,
    AUTOCOMPLETE_PASSWORD_NEW,
    AUTOCOMPLETE_ONE_TIME_CODE,
    AUTOCOMPLETE_ORGANIZATION,
    AUTOCOMPLETE_ORGANIZATION_TITLE,
    AUTOCOMPLETE_STREET_ADDRESS,
    AUTOCOMPLETE_ADDRESS_LINE_1,
    AUTOCOMPLETE_ADDRESS_LINE_2,
    AUTOCOMPLETE_ADDRESS_LINE_3,
    AUTOCOMPLETE_ADDRESS_LEVEL_4,
    AUTOCOMPLETE_ADDRESS_LEVEL_3,
    AUTOCOMPLETE_ADDRESS_LEVEL_2,
    AUTOCOMPLETE_ADDRESS_LEVEL_1,
    AUTOCOMPLETE_COUNTRY,
    AUTOCOMPLETE_COUNTRY_NAME,
    AUTOCOMPLETE_POSTAL_CODE,
    AUTOCOMPLETE_CC_NAME,
    AUTOCOMPLETE_CC_NAME_GIVEN,
    AUTOCOMPLETE_CC_NAME_ADDITIONAL,
    AUTOCOMPLETE_CC_SURNAME,
    AUTOCOMPLETE_CC_NUMBER,
    AUTOCOMPLETE_CC_EXPIRY,
    AUTOCOMPLETE_CC_EXPIRY_MONTH,
    AUTOCOMPLETE_CC_EXPIRY_YEAR,
    AUTOCOMPLETE_CC_CSC,
    AUTOCOMPLETE_CC_TYPE,
    AUTOCOMPLETE_TRANSACTION_CURRENCY,
    AUTOCOMPLETE_TRANSACTION_AMOUNT,
    AUTOCOMPLETE_LANGUAGE,
    AUTOCOMPLETE_BIRTHDAY,
    AUTOCOMPLETE_BIRTHDAY_DAY,
    AUTOCOMPLETE_BIRTHDAY_MONTH,
    AUTOCOMPLETE_BIRTHDAY_YEAR,
    AUTOCOMPLETE_URL,
    AUTOCOMPLETE_PHOTO,
    AUTOCOMPLETE_TEL,
    AUTOCOMPLETE_TEL_COUNTRY_CODE,
    AUTOCOMPLETE_TEL_NATIONAL,
    AUTOCOMPLETE_TEL_AREA_CODE,
    AUTOCOMPLETE_TEL_LOCAL,
    AUTOCOMPLETE_TEL_LOCAL_PREFIX,
    AUTOCOMPLETE_TEL_LOCAL_SUFFIX,
    AUTOCOMPLETE_TEL_EXTENSION,
    AUTOCOMPLETE_USERNAME,
    AUTOCOMPLETE_USERNAME_NEW
];


// ------ types
export const TYPE_EMAIL = 'email';
export const TYPE_NUMBER = 'number';
export const TYPE_PASSWORD = 'password';
export const TYPE_PHONE = 'phone';
export const TYPE_TEXT = 'text';

export const TYPES = [
    TYPE_EMAIL,
    TYPE_NUMBER,
    TYPE_PASSWORD,
    TYPE_PHONE,
    TYPE_TEXT
];
